import http from "../common/http-common";
import authHeader from '../common/auth-header';




//body: JSON.stringify(aCase)


class ContractDataService {





    getAll(params) {
        //console.log(params);
        var headers = authHeader();
        var config = {
            headers,
            params: params,
        }
        //console.log(config)

        return http.get("/contracts", config);
    }


    buildPdfContract(id) {

        var headers = authHeader();
        let config = {
            responseType: 'blob',
            headers,
        }
        console.log(config)

        return http.get(`/contracts/pdf/${id}`, config);
    }

    sendPdfContract(id) {

        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)

        return http.get(`/contracts/pdfsend/${id}`, config);
    }




    get(id) {
        return http.get(`/contracts/${id}`);
    }

    create(event) {
        var headers = authHeader();
        console.log('event.target.startDate.value : '+event.target.startDate.value);
        var raw = JSON.stringify({
            "startDate": event.target.startDate.value,
            "signingDate": event.target.signingDate.value,
            "student": {
                "firstName": event.target.firstName.value,
                "lastName": event.target.lastName.value,
                "email": event.target.email.value,
                "phone": event.target.phone.value,
                "address": event.target.address.value,
                "zipCode": event.target.zipCode.value,
                "city": event.target.city.value,
                "country": "France"
            }
          });

        console.log(raw);
        let config = {
            headers,
        }
        return http.post("/contracts", raw, config);
    }

    update(id, event) {
        var headers = authHeader();
        console.log('event.target.studentId.value : '+event.target.studentId.value);
        console.log(event);
        var raw = JSON.stringify({
            "startDate": event.target.startDate.value,
            "signingDate": event.target.signingDate.value,
            "student": {
                "id" : event.target.studentId.value,
                "firstName": event.target.firstName.value,
                "lastName": event.target.lastName.value,
                "email": event.target.email.value,
                "phone": event.target.phone.value,
                "address": event.target.address.value,
                "zipCode": event.target.zipCode.value,
                "city": event.target.city.value,
                "country": "France"
            }
          });


        console.log(raw);
        let config = {
            headers,
        }
        return http.put(`/contracts/${id}`, raw, config);
    }

    delete(id) {
        return http.delete(`/contracts/${id}`);
    }

    deleteAll() {
        return http.delete("/contracts");
    }



}

export default new ContractDataService();